<template lang="pug">
    .section-animation(
        ref='animblock'
        )
        .barbwire(
            ref='barbwire'
            )
            .barbwire__item
                .barbwire__item-bg(
                    ref='bwitemone'
                    )
                svg(width='1280', height='368', viewBox='0 0 1280 368')
                    path(d='M1306.69 39.974l-103.23 21.41.52-2.707c.63-3.392-.02-37.398-1.99-38.139-1.6-.15-9.62 32.511-10.26 35.846l-.62 3.392-1.84-2.76c-1.93-2.864-5.82-3.568-8.62-1.657-2.39 1.583-3.28 4.548-2.38 7.141l-2-2.91a6.067 6.067 0 00-3.98-2.618 6.382 6.382 0 00-4.69.973 6.101 6.101 0 00-2.62 3.986 5.43 5.43 0 00-.08 1.649l-.96-1.432a6.09 6.09 0 00-3.98-2.618 6.383 6.383 0 00-4.69.972 6.065 6.065 0 00-2.62 3.987c-.12.57-.13 1.115-.08 1.648l-.96-1.432a6.087 6.087 0 00-3.99-2.617 6.392 6.392 0 00-4.69.972 6.087 6.087 0 00-2.61 3.987c-.19 1.127-.14 2.263.28 3.386l-2.01-2.968c-1.92-2.864-22.26-29.585-23.67-28.809-1.5 1.461 11.43 32.979 13.34 35.785l1.56 2.275-188.285 39.05.526-2.708c.625-3.392-.027-37.398-1.992-38.138-1.601-.152-9.623 32.51-10.26 35.845l-.625 3.393-1.84-2.761c-1.923-2.864-5.813-3.568-8.618-1.657-2.389 1.583-3.283 4.548-2.383 7.141l-1.993-2.91a6.088 6.088 0 00-3.985-2.618 6.389 6.389 0 00-4.69.973 6.084 6.084 0 00-2.615 3.987 5.306 5.306 0 00-.081 1.648l-.961-1.432a6.089 6.089 0 00-3.985-2.618 6.384 6.384 0 00-4.69.973 6.087 6.087 0 00-2.616 3.986 5.343 5.343 0 00-.081 1.649l-.961-1.432a6.08 6.08 0 00-3.985-2.618 6.388 6.388 0 00-4.69.972 6.09 6.09 0 00-2.615 3.987c-.189 1.127-.135 2.264.279 3.386l-2.004-2.968c-1.923-2.864-22.26-29.584-23.669-28.809-1.509 1.461 11.429 32.979 13.34 35.785l1.559 2.275-188.288 39.05.526-2.707c.625-3.393-.026-37.399-1.992-38.139-1.601-.151-9.623 32.511-10.26 35.845l-.624 3.393-1.841-2.76c-1.923-2.865-5.813-3.569-8.617-1.658-2.389 1.584-3.284 4.549-2.384 7.142l-1.993-2.911a6.083 6.083 0 00-3.985-2.617 6.382 6.382 0 00-4.689.972 6.088 6.088 0 00-2.616 3.987 5.336 5.336 0 00-.081 1.648l-.961-1.432a6.084 6.084 0 00-3.985-2.618 6.384 6.384 0 00-4.69.973 6.081 6.081 0 00-2.615 3.987 5.304 5.304 0 00-.081 1.648l-.961-1.432a6.088 6.088 0 00-3.986-2.618 6.382 6.382 0 00-4.689.973 6.087 6.087 0 00-2.616 3.986c-.189 1.127-.134 2.264.28 3.387l-2.005-2.969c-1.922-2.864-22.259-29.584-23.668-28.808-1.509 1.461 11.429 32.978 13.339 35.785l1.559 2.275-187.998 38.989.526-2.707c.589-3.567-.063-37.572-2.04-38.371-1.601-.151-9.623 32.511-10.26 35.846l-.625 3.392-1.84-2.76c-1.923-2.864-5.813-3.568-8.617-1.657-2.39 1.583-3.284 4.548-2.384 7.141l-1.993-2.91a6.084 6.084 0 00-3.985-2.618 6.385 6.385 0 00-4.69.973 6.085 6.085 0 00-2.615 3.986 5.312 5.312 0 00-.081 1.649l-.961-1.432a6.085 6.085 0 00-3.985-2.618 6.388 6.388 0 00-4.69.972 6.091 6.091 0 00-2.616 3.987 5.306 5.306 0 00-.08 1.648l-.962-1.432a6.088 6.088 0 00-3.985-2.618 6.39 6.39 0 00-4.69.973 6.087 6.087 0 00-2.615 3.987c-.189 1.127-.134 2.263.28 3.386l-2.005-2.968c-1.807-2.888-22.156-29.667-23.565-28.891-1.509 1.461 11.429 32.979 13.34 35.785l1.559 2.275-188.288 39.05.526-2.708c.625-3.392-.026-37.398-1.992-38.138-1.601-.152-9.623 32.51-10.26 35.845l-.625 3.393-1.84-2.761c-1.923-2.864-5.813-3.568-8.617-1.657-2.389 1.583-3.284 4.548-2.384 7.141l-1.993-2.91a6.088 6.088 0 00-3.985-2.618 6.39 6.39 0 00-4.69.973 6.085 6.085 0 00-2.615 3.987 5.336 5.336 0 00-.081 1.648l-.961-1.432a6.086 6.086 0 00-3.985-2.618 6.384 6.384 0 00-4.69.973 6.082 6.082 0 00-2.615 3.986 5.282 5.282 0 00-.081 1.649l-.962-1.433a6.083 6.083 0 00-3.985-2.617 6.387 6.387 0 00-4.69.972 6.088 6.088 0 00-2.615 3.987c-.189 1.127-.134 2.264.28 3.386l-2.005-2.968c-1.922-2.864-22.26-29.584-23.669-28.809-1.508 1.461 11.43 32.979 13.34 35.785l1.559 2.275-108.04 22.407 2.536 12.224 103.233-21.41-.525 2.707c-.625 3.393.026 37.399 1.992 38.139 1.601.151 9.623-32.511 10.26-35.845l.624-3.393 1.841 2.76c1.923 2.865 5.813 3.569 8.617 1.658a6.217 6.217 0 002.348-7.315l2.004 2.968a6.087 6.087 0 003.986 2.617 6.382 6.382 0 004.689-.972 6.089 6.089 0 002.616-3.987 5.336 5.336 0 00.081-1.648l.961 1.432a6.084 6.084 0 003.985 2.618 6.384 6.384 0 004.69-.973 6.081 6.081 0 002.615-3.987 5.304 5.304 0 00.081-1.648l.961 1.432a6.089 6.089 0 003.985 2.618 6.388 6.388 0 004.69-.972 6.091 6.091 0 002.616-3.987c.201-1.069.1-2.136-.232-3.155l1.993 2.91c1.922 2.865 22.259 29.585 23.668 28.809 1.509-1.461-11.429-32.978-13.339-35.785l-1.559-2.275 188.287-39.049-.525 2.707c-.625 3.393.026 37.398 1.991 38.139 1.602.151 9.623-32.511 10.26-35.846l.625-3.392 1.841 2.76c1.922 2.864 5.812 3.568 8.617 1.657a6.216 6.216 0 002.348-7.315l2.004 2.968a6.083 6.083 0 003.985 2.618 6.388 6.388 0 004.69-.972 6.086 6.086 0 002.615-3.987c.124-.57.132-1.115.081-1.648l.962 1.432a6.088 6.088 0 003.985 2.618 6.387 6.387 0 004.689-.973 6.085 6.085 0 002.616-3.987 5.336 5.336 0 00.081-1.648l.961 1.432a6.086 6.086 0 003.985 2.618 6.384 6.384 0 004.69-.973 6.082 6.082 0 002.615-3.986c.201-1.069.101-2.136-.231-3.155l1.992 2.91c1.923 2.864 22.26 29.585 23.669 28.809 1.509-1.461-11.429-32.979-13.34-35.785l-1.558-2.275 188.287-39.049-.526 2.707c-.625 3.392.027 37.398 1.992 38.138 1.601.152 9.623-32.51 10.26-35.845l.625-3.393 1.84 2.761c1.923 2.864 5.813 3.568 8.618 1.657 2.435-1.653 3.317-4.676 2.347-7.315l2.005 2.968a6.084 6.084 0 003.985 2.618 6.385 6.385 0 004.69-.973 6.085 6.085 0 002.615-3.986c.124-.57.131-1.115.081-1.649l.961 1.432a6.085 6.085 0 003.985 2.618 6.388 6.388 0 004.69-.972 6.091 6.091 0 002.616-3.987c.123-.57.131-1.115.08-1.648l.962 1.432a6.088 6.088 0 003.985 2.618 6.389 6.389 0 004.69-.973 6.087 6.087 0 002.615-3.987c.201-1.069.101-2.136-.231-3.154l1.992 2.91c1.923 2.864 22.26 29.584 23.669 28.809 1.508-1.461-11.429-32.979-13.34-35.785l-1.559-2.275 187.998-38.99-.526 2.708c-.625 3.392.027 37.398 1.992 38.138 1.602.151 9.623-32.511 10.26-35.845l.625-3.393 1.841 2.761c1.922 2.864 5.812 3.568 8.617 1.657 2.435-1.653 3.317-4.676 2.347-7.315l2.005 2.968a6.088 6.088 0 003.985 2.618 6.389 6.389 0 004.69-.973 6.084 6.084 0 002.615-3.987 5.306 5.306 0 00.081-1.648l.961 1.432a6.088 6.088 0 003.986 2.618 6.382 6.382 0 004.689-.973 6.087 6.087 0 002.616-3.986c.123-.57.131-1.115.081-1.649l.961 1.432a6.08 6.08 0 003.985 2.618 6.388 6.388 0 004.69-.972 6.086 6.086 0 002.615-3.987c.201-1.069.101-2.136-.231-3.155l1.992 2.911c1.923 2.864 22.26 29.584 23.669 28.808 1.509-1.461-11.429-32.978-13.34-35.785l-1.559-2.275 188.292-39.049-.53 2.707c-.62 3.393.03 37.398 1.99 38.139 1.6.151 9.62-32.51 10.26-35.845l.63-3.393 1.84 2.76c1.92 2.865 5.81 3.568 8.61 1.657 2.44-1.653 3.32-4.676 2.35-7.315l2.01 2.969a6.067 6.067 0 003.98 2.617c1.57.28 3.26-.01 4.69-.972a6.102 6.102 0 002.62-3.987c.12-.57.13-1.115.08-1.648l.96 1.432a6.09 6.09 0 003.98 2.618c1.57.279 3.26-.011 4.69-.973a6.065 6.065 0 002.62-3.987c.12-.57.13-1.115.08-1.648l.96 1.432a6.087 6.087 0 003.99 2.618c1.56.28 3.26-.011 4.69-.973a6.087 6.087 0 002.61-3.986c.2-1.07.1-2.136-.23-3.155l1.99 2.91c1.93 2.865 22.26 29.585 23.67 28.809 1.51-1.461-11.43-32.979-13.34-35.785l-1.56-2.275 107.93-22.383-2.54-12.224z', fill='red')
            .barbwire__item
                .barbwire__item-bg(
                    ref='bwitemtwo'
                    )
                svg(width='1280', height='180', viewBox='0 0 1280 180')
                    path(d='M1307.2 127.207l-105.21-6.713 1.22-2.471c1.5-3.106 9.89-36.068 8.19-37.303-1.51-.57-17.9 28.798-19.39 31.845l-1.51 3.105-1.04-3.149c-1.09-3.271-4.66-4.981-7.87-3.882-2.72.894-4.37 3.516-4.19 6.255l-1.15-3.335a6.09 6.09 0 00-3.15-3.58 6.387 6.387 0 00-4.78-.305 6.121 6.121 0 00-3.58 3.151c-.27.517-.42 1.04-.51 1.568l-.55-1.636a6.09 6.09 0 00-3.15-3.58 6.387 6.387 0 00-4.78-.305 6.121 6.121 0 00-3.58 3.151 5.23 5.23 0 00-.51 1.568l-.55-1.636a6.09 6.09 0 00-3.15-3.58 6.387 6.387 0 00-4.78-.305 6.121 6.121 0 00-3.58 3.151c-.48 1.037-.73 2.147-.62 3.34l-1.15-3.394c-1.1-3.271-13.62-34.425-15.19-34.05-1.84 1.008 2.28 34.828 3.38 38.04l.9 2.607-191.903-12.245 1.225-2.471c1.501-3.106 9.885-36.068 8.186-37.303-1.504-.57-17.894 28.798-19.392 31.845l-1.502 3.106-1.043-3.15c-1.095-3.271-4.66-4.98-7.87-3.881-2.723.893-4.372 3.515-4.191 6.254l-1.15-3.334a6.086 6.086 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.306 6.083 6.083 0 00-3.578 3.151 5.319 5.319 0 00-.515 1.568l-.547-1.635a6.09 6.09 0 00-3.149-3.58 6.386 6.386 0 00-4.78-.306 6.088 6.088 0 00-3.579 3.151 5.316 5.316 0 00-.514 1.568l-.548-1.635a6.083 6.083 0 00-3.149-3.58 6.386 6.386 0 00-4.78-.306 6.086 6.086 0 00-3.578 3.151c-.481 1.037-.729 2.148-.628 3.34l-1.146-3.394c-1.095-3.27-13.624-34.425-15.188-34.05-1.842 1.008 2.281 34.828 3.379 38.04l.901 2.607-191.904-12.245 1.224-2.47c1.502-3.107 9.886-36.069 8.187-37.304-1.504-.57-17.895 28.798-19.393 31.845l-1.501 3.106-1.044-3.15c-1.094-3.271-4.659-4.98-7.869-3.881-2.724.893-4.372 3.515-4.191 6.254l-1.151-3.334a6.085 6.085 0 00-3.148-3.58 6.386 6.386 0 00-4.78-.305 6.088 6.088 0 00-3.579 3.15 5.287 5.287 0 00-.514 1.569l-.548-1.636a6.083 6.083 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.305 6.086 6.086 0 00-3.578 3.15 5.319 5.319 0 00-.515 1.569l-.547-1.636a6.09 6.09 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.305 6.083 6.083 0 00-3.578 3.15c-.481 1.037-.73 2.148-.628 3.34l-1.146-3.393c-1.095-3.272-13.624-34.426-15.188-34.052-1.842 1.01 2.28 34.829 3.379 38.041l.9 2.607-191.608-12.226 1.224-2.47c1.513-3.284 9.897-36.246 8.202-37.54-1.505-.57-17.895 28.798-19.393 31.845l-1.502 3.106-1.043-3.15c-1.095-3.271-4.659-4.98-7.87-3.881-2.723.893-4.371 3.515-4.191 6.254l-1.15-3.334a6.083 6.083 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.306 6.086 6.086 0 00-3.578 3.151 5.319 5.319 0 00-.515 1.568l-.547-1.635a6.086 6.086 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.306 6.083 6.083 0 00-3.578 3.151 5.319 5.319 0 00-.515 1.568l-.547-1.635a6.09 6.09 0 00-3.149-3.58 6.386 6.386 0 00-4.78-.306 6.088 6.088 0 00-3.579 3.152c-.481 1.036-.729 2.147-.627 3.339l-1.147-3.393c-.976-3.264-13.501-34.478-15.066-34.103-1.842 1.009 2.281 34.828 3.38 38.04l.9 2.607-191.904-12.244 1.224-2.471c1.502-3.106 9.886-36.068 8.187-37.303-1.504-.57-17.895 28.798-19.392 31.845l-1.502 3.105-1.043-3.15c-1.095-3.27-4.66-4.98-7.87-3.88-2.724.893-4.372 3.515-4.191 6.253l-1.15-3.334a6.09 6.09 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.305 6.085 6.085 0 00-3.579 3.151 5.315 5.315 0 00-.514 1.568l-.548-1.636a6.086 6.086 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.305 6.086 6.086 0 00-3.578 3.151 5.318 5.318 0 00-.515 1.568l-.547-1.636a6.086 6.086 0 00-3.149-3.58 6.385 6.385 0 00-4.78-.305 6.085 6.085 0 00-3.578 3.151c-.481 1.037-.73 2.147-.628 3.34l-1.146-3.394C69.289 37.728 56.76 6.573 55.196 6.948c-1.842 1.009 2.28 34.828 3.38 38.04l.9 2.608L-50.64 40.57l-.795 12.459 105.216 6.713-1.224 2.471c-1.501 3.106-9.885 36.068-8.186 37.303 1.504.57 17.894-28.798 19.392-31.845l1.502-3.106 1.043 3.15c1.095 3.271 4.66 4.98 7.87 3.881a6.216 6.216 0 004.202-6.431l1.147 3.393a6.086 6.086 0 003.148 3.58 6.385 6.385 0 004.78.305 6.086 6.086 0 003.579-3.15c.27-.517.422-1.04.514-1.568l.548 1.635a6.086 6.086 0 003.149 3.58 6.387 6.387 0 004.78.306 6.086 6.086 0 003.578-3.151c.27-.517.422-1.04.515-1.569l.547 1.636a6.086 6.086 0 003.149 3.58 6.386 6.386 0 004.78.305 6.083 6.083 0 003.578-3.15c.477-.978.663-2.033.613-3.104l1.15 3.334c1.095 3.272 13.624 34.426 15.188 34.052 1.842-1.009-2.281-34.829-3.379-38.041l-.901-2.607 191.904 12.245-1.224 2.47c-1.502 3.107-9.886 36.069-8.187 37.304 1.504.57 17.895-28.799 19.393-31.845l1.501-3.106 1.044 3.15c1.094 3.271 4.659 4.98 7.869 3.881a6.216 6.216 0 004.203-6.431l1.146 3.393a6.086 6.086 0 003.149 3.58 6.386 6.386 0 004.78.305 6.084 6.084 0 003.578-3.15c.27-.517.422-1.04.515-1.569l.547 1.636a6.09 6.09 0 003.149 3.58 6.386 6.386 0 004.78.305 6.088 6.088 0 003.579-3.15c.27-.517.421-1.04.514-1.569l.548 1.636a6.083 6.083 0 003.149 3.58 6.385 6.385 0 004.78.305 6.086 6.086 0 003.578-3.15c.477-.978.663-2.033.613-3.104l1.15 3.334c1.095 3.272 13.623 34.426 15.188 34.052 1.842-1.009-2.281-34.829-3.38-38.041l-.9-2.607L587.714 93.81l-1.224 2.47c-1.502 3.106-9.886 36.069-8.187 37.304 1.504.57 17.894-28.799 19.392-31.845l1.502-3.106 1.043 3.15c1.095 3.271 4.66 4.981 7.87 3.881a6.216 6.216 0 004.202-6.431l1.147 3.393a6.08 6.08 0 003.149 3.58 6.383 6.383 0 004.78.305 6.085 6.085 0 003.578-3.151c.27-.516.422-1.04.515-1.568l.547 1.636a6.083 6.083 0 003.149 3.58 6.383 6.383 0 004.78.305 6.082 6.082 0 003.578-3.151c.27-.516.422-1.04.515-1.568l.547 1.636a6.087 6.087 0 003.149 3.58 6.383 6.383 0 004.78.305 6.087 6.087 0 003.579-3.151c.477-.977.663-2.033.612-3.103l1.15 3.334c1.095 3.272 13.624 34.426 15.188 34.051 1.842-1.008-2.281-34.828-3.379-38.04l-.9-2.607 191.608 12.226-1.224 2.471c-1.502 3.106-9.885 36.068-8.187 37.303 1.505.57 17.895-28.799 19.393-31.845l1.502-3.106 1.043 3.15c1.095 3.271 4.659 4.981 7.87 3.881a6.216 6.216 0 004.202-6.431l1.146 3.393a6.087 6.087 0 003.149 3.58 6.383 6.383 0 004.78.305 6.082 6.082 0 003.578-3.151c.27-.516.422-1.04.515-1.568l.548 1.636a6.08 6.08 0 003.149 3.58 6.38 6.38 0 004.779.305 6.087 6.087 0 003.579-3.151c.27-.516.422-1.04.515-1.568l.547 1.636a6.08 6.08 0 003.149 3.58 6.383 6.383 0 004.78.305 6.082 6.082 0 003.578-3.151c.477-.977.663-2.033.613-3.103l1.15 3.334c1.095 3.272 13.623 34.426 15.188 34.052 1.842-1.009-2.281-34.829-3.38-38.041l-.9-2.607 191.904 12.244-1.22 2.472c-1.51 3.105-9.89 36.068-8.19 37.302 1.5.571 17.89-28.798 19.39-31.844l1.5-3.106 1.05 3.149c1.09 3.272 4.66 4.981 7.87 3.882 2.78-.949 4.43-3.63 4.2-6.431l1.14 3.393a6.117 6.117 0 003.15 3.58c1.44.685 3.15.853 4.78.305a6.06 6.06 0 003.58-3.151c.27-.516.42-1.04.52-1.568l.54 1.636a6.117 6.117 0 003.15 3.58c1.44.685 3.15.853 4.78.305a6.06 6.06 0 003.58-3.151c.27-.516.42-1.04.52-1.568l.54 1.636a6.085 6.085 0 003.15 3.58c1.44.685 3.15.853 4.78.305a6.06 6.06 0 003.58-3.151c.48-.977.66-2.033.61-3.103l1.15 3.334c1.1 3.271 13.63 34.426 15.19 34.051 1.84-1.009-2.28-34.828-3.38-38.04l-.9-2.607 110 7.018.79-12.459z', fill='red')

        .section(
            ref='section'
            )

            .section__image-wrapper
                .section__image-grid-container
                    .section__image-container
                        img.section__image(
                            :src='require(`@/assets/img/selector/${sectionItem.id}.jpg`)'
                        )
            .section__text-btn-cnt(:class='{show: isActive}')
                router-link.section__text-wrapper(
                    :to='`/opg/${sectionItem.id}`'
                    :class='{active: isActive}'
                    )
                    span.section__text-block(
                        v-for='(text, blockIndex) in sectionItem.textblock'
                        )

                        span.section__text(
                            v-html='text'
                        )
                        span.section__text--white(
                            v-html='text'
                        )
                        br
                .btn-part-wrp(ref='btnPart')
                    //-button.btn-part.btn-part_prev(v-html='sectionItem.arrows.prev')
                    button.btn-part.btn-part_next(
                        @click='$emit("nextSection")'
                    )
                        span(v-html='sectionItem.arrows.next')
                        span.btn-part_announce(v-if='sectionItem.arrows.announce' v-html='sectionItem.arrows.announce')



</template>
<script>
import {gsap} from 'gsap';
export default {
    data() {
        return {
            tl: null
        };
    },

    props: {
        sectionItem: Object,
        isActive: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        isActive(res) {
            if (res) {
                this.showBlock();
            } else {
                this.hideBlock();
            }
        }
    },

    methods: {
        showBlock() {
            const sendEndEvent = () => this.$emit('showend');

            this.tl = gsap.timeline({paused: true, onComplete: sendEndEvent});

            // this.tl
            //     .fromTo(this.$refs.animblock, 0.5, {opacity: 0}, {opacity: 1}, 'start+=0.5')
            //     .staggerFromTo([...this.$refs.section.querySelectorAll('.section__text')], 0.5, {y: '140%'}, {y: '0%'}, 0.2, 'start+=0.8')
            //     .fromTo(this.$refs.barbwire, 0.001, {opacity: 0}, {opacity: 1}, 'start+=0.8')
            //     .fromTo(this.$refs.bwitemone, 0.8, {scaleX: 1}, {scaleX: 0}, 'start+=1.1')
            //     .fromTo(this.$refs.bwitemtwo, 0.8, {scaleX: 1}, {scaleX: 0}, 'start+=1.3')
            //     .fromTo(this.$refs.animblock.querySelector('.section__image'), 1, {x: '100%'}, {x: '0%'}, 'start+=2.5')
            //     .staggerFromTo([...this.$refs.section.querySelectorAll('.section__text--white')], 0.5, {opacity: 0}, {opacity: 1}, 0.05, 'start+=2.5')
            //     .staggerFromTo([...this.$refs.section.querySelectorAll('.section__text')], 0.5, {opacity: 1}, {opacity: 0}, 0.05);

            this.tl
                .fromTo(this.$refs.animblock, {opacity: 0}, {duration: 0.5, opacity: 1}, 'start+=0.5')
                .fromTo(
                    [...this.$refs.section.querySelectorAll('.section__text--white')],
                    {y: '140%'},
                    {duration: 0.5, y: '0%', stagger: {each: 0.2}},
                    'start+=0.8'
                )
                .fromTo([...this.$refs.section.querySelectorAll('.section__text')], {y: '140%'}, {duration: 0.5, y: '0%', stagger: {each: 0.2}}, 'start+=0.8')
                .fromTo(this.$refs.barbwire, {opacity: 0}, {duration: 0.001, opacity: 1}, 'start+=0.8')
                .fromTo(this.$refs.bwitemone, {scaleX: 1}, {duration: 0.8, scaleX: 0}, 'start+=1.1')
                .fromTo(this.$refs.bwitemtwo, {scaleX: 1}, {duration: 0.8, scaleX: 0}, 'start+=1.3')
                .fromTo(this.$refs.animblock.querySelector('.section__image'), {x: '101%'}, {duration: 1, x: '0%'}, 'start+=2.5')
                .fromTo(
                    [...this.$refs.section.querySelectorAll('.section__text--white')],
                    {opacity: 0},
                    {duration: 0.5, opacity: 1, stagger: {each: 0.05}},
                    'start+=2.5'
                )
                .fromTo(this.$refs.btnPart, {opacity: 0}, {duration: 0.2, opacity: 1}, 'start+=2.7')
                .fromTo(
                    [...this.$refs.section.querySelectorAll('.section__text')],
                    {opacity: 1},
                    {duration: 0.5, opacity: 0, stagger: {each: 0.05}},
                    'start+=2.7'
                );

            this.tl.play();
        },

        hideBlock() {
            const sendEndEvent = () => {
                this.$emit('hideend');
                this.destroyAnimation();
            };

            if (this.tl) this.tl.kill();

            this.tl = gsap.timeline({paused: true, onComplete: sendEndEvent});

            this.tl
                .fromTo(this.$refs.animblock.querySelector('.section__image'), 1, {x: '0%'}, {x: '-101%', ease: 'power2.in'}, 'start')
                .fromTo(
                    [...this.$refs.animblock.querySelectorAll('.section__text--white')],
                    {y: '0%'},
                    {duration: 0.5, y: '-140%', ease: 'power2.in', stagger: {each: 0.2}},
                    'start+=0.2'
                )
                .fromTo(this.$refs.barbwire, {duration: 0.2, opacity: 1}, {opacity: 0}, 'start+=1');

            this.tl.play();
        },

        destroyAnimation() {
            if (this.tl) this.tl.kill();
        }
    },

    beforeDestroy() {
        this.destroyAnimation();
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.btn-part {
    color: #fff;
    text-align: left;
    transition: opacity 0.5s ease;
    @media (--viewport-tablet) {
        font-family: var(--font-main);
        font-size: 11.5px;
        text-transform: uppercase;
        font-weight: bold;
    }
    &_next {
        width: 174px;
        margin-left: auto;
        @media (--viewport-tablet) {
            width: auto;
        }
    }
    &-wrp {
        pointer-events: all;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: relative;
        z-index: 2;
        opacity: 0;
        transition: 1s;
        transition-delay: 1s;
        margin-top: 28px;
        @media (--viewport-tablet) {
            margin-top: 14vh;
            padding: 0 var(--grid-column-mobile);
        }
        &.show {
            opacity: 1;
        }
    }
    &_announce {
        display: block;
        font-family: var(--font-main);
        font-size: 0.75rem;
        text-transform: uppercase;
        font-weight: bold;
        margin-top: 10px;
        @media (--viewport-tablet) {
            font-size: 9px;
        }
    }
}

.section-animation {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.section {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    &__image-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__image-grid-container {
        position: relative;
        width: var(--grid-width);
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        @media (--viewport-laptop) {
            width: 100%;
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__image-container {
        width: calc(var(--grid-column) * 18);
        height: calc((var(--grid-column) * 18) * (439 / 876));
        overflow: hidden;

        @media (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 18);
            height: calc((var(--grid-column-laptop) * 18) * (439 / 876));
        }

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            height: 70vh;
        }
    }

    &__image {
        width: 100%;
        height: auto;
        transform: translateX(101%);

        @media (--viewport-tablet) {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
    &__text-btn-cnt {
        position: relative;
        width: calc(50vw + var(--grid-width) / 2);
        margin-left: auto;
        color: white;
        font-family: var(--font-accent);
        //font-size: 6.6666rem;
        line-height: 1.2;
        opacity: 0;
        pointer-events: none;
        padding-right: 0;
        &.show {
            opacity: 1;
        }
        @media (--viewport-laptop) {
            width: 100%;
            padding: 77px 0 0 var(--grid-column-laptop);
        }
        @media (--viewport-tablet) {
            width: auto;
            height: auto;
            padding-top: 0px;
            top: 77px;
            padding-left: 0;
            padding-right: 0;
        }
    }
    &__text-wrapper {
        position: relative;
        display: block;
        z-index: 20;
        //width: var(--grid-width);
        // margin: 0 auto;
        padding-top: 77px;
        pointer-events: none;
        &.active {
            pointer-events: all;
        }
        @media (--viewport-laptop) {
            // width: 100%;
            // padding: 77px var(--grid-column-laptop) 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            // width: auto;
            // height: auto;
            // padding-top: 0px;
            // top: 77px;
        }
    }

    &.active {
        .section__text-wrapper {
            pointer-events: all;
        }
    }

    &__text-block {
        position: relative;
        display: block;
        overflow: hidden;
    }

    &__text {
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: url(../../assets/img/selector/firstbandera-fill.jpg);
        background-size: cover;
        transform: translateY(150%);

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }

    &__text--white {
        position: absolute;
        left: 0;
        // top: -11px;
        top: 0;
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        opacity: 0;
        z-index: 10;

        @media (--viewport-tablet) {
            // top: -8%;
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}

.barbwire {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    opacity: 0;

    &__item {
        position: relative;
        width: 100%;
        height: 50%;
        pointer-events: none;

        &-bg {
            display: inline-block;
            background: black;
            position: absolute;
            width: 100%;
            height: 100%;
            transform-origin: 0% 0;
            z-index: 16;
        }

        svg {
            width: 100%;
            height: auto;
        }

        &:nth-child(2) {
            svg {
                position: relative;
                z-index: 15;
            }
        }
    }
}
</style>
